<template>
  <el-dialog
    title="Adicionar item ao recibo"
    :visible.sync="visibility"
    :before-close="fechar"
    :close-on-click-modal="false"
    append-to-body
    width="40%"
  >
    <el-row>
      <el-col>
        <el-form
          ref="form"
          :model="itemRecibo"
          :rules="validacao"
          size="small"
          hide-required-asterisk
          :show-message="false"
          label-position="top"
        >
          <el-row :gutter="20">
            <el-col>
              <el-form-item label="Perfil do Cliente" prop="categoriaCliente">
                <el-select
                  v-model="itemRecibo.categoriaCliente"
                  value-key="data"
                  placeholder="Selecione"
                  style="width: 100%">
                    <el-option
                      v-for="item in perfisCliente"
                      :key="item.data"
                      :label="item.label"
                      :value="item.data">
                    </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col>
              <el-form-item label="Tipo" prop="tipo">
                <el-select
                  v-model="itemRecibo.tipo"
                  value-key="data"
                  placeholder="Selecione"
                  style="width: 100%">
                    <el-option
                      v-for="item in tiposItem"
                      :key="item.data"
                      :label="item.label"
                      :value="item.data">
                    </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col>
              <el-form-item label="Descrição" prop="nome">
                <el-input v-model="itemRecibo.nome"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col>
              <el-form-item label="Valor" prop="valor">
                <div class="el-input el-input--small">
                  <money
                    v-model="itemRecibo.valor"
                    v-bind="money"
                    class="el-input__inner" />
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>

    <span slot="footer" class="dialog-footer">
      <el-button
        @click="validarAdicao"
        type="success"
        size="small"
        round
        class="btn-box-shadow"
      >
        Gravar
      </el-button>

      <el-button
        @click="fechar()"
        type="danger"
        size="small"
        round
        class="btn-box-shadow"
      >
        Fechar
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from "vuex";

import { Money } from 'v-money';

import { PERFIL_CLIENTE_ITEM_RECIBO, TIPO_ITEM_RECIBO } from "../../../util/constantes.js";

export default {
  components: {
    Money,
  },

  props: {
    visibility: Boolean,
  },

  data() {
    return {
      itemRecibo: {
        categoriaCliente: '',
        tipo: '',
        nome: '',
        valor: 0,
      },

      validacao: {
        categoriaCliente: [
          { required: true, message: "A categoria do cliente é obrigatório" }
        ],
        tipo: [
          { required: true, message: "O tipo é obrigatório" }
        ],
        nome: [
          { required: true, message: "O nome é obrigatório" }
        ],
        valor: [
          { type: "number", min: 0.01 }
        ]
      },

      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
    };
  },

  computed: {
    perfisCliente() { return PERFIL_CLIENTE_ITEM_RECIBO },
    tiposItem() { return TIPO_ITEM_RECIBO },
  },

  methods: {
    ...mapActions('parametrosStore', [
      'adicionarItemReciboAutomatico',
    ]),

    validarAdicao() {
      this.$refs['form'].validate(isValid => {
        const formIsNotValid = !isValid;
        if(formIsNotValid) {
          this.exibirAlert('Preencha todos os campos obrigatórios');
          return;
        }

        this.adicionar();
      });
    },

    adicionar() {
      const payload = { ...this.itemRecibo };
      this.adicionarItemReciboAutomatico(payload);
      this.fechar();
    },

    exibirAlert(mensagem) {
      this.$alert(mensagem, 'Atenção', { confirmButtonText: 'OK', type: 'warning' });
    },

    reset() {
      this.itemRecibo = {
        categoriaCliente: '',
        tipo: '',
        nome: '',
        valor: 0,
      };

      this.$refs["form"].resetFields();
    },

    fechar() {
      this.$emit('close');
      this.reset();
    },
  }
}
</script>